import axios from 'axios';

// Use IP address for API URL
const API_URL = process.env.REACT_APP_API_URL || `http://192.168.18.15:5000/api`;

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = axios.defaults.headers.common['Authorization'];
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Financial Data API
export const financialAPI = {
  // Get all financial data
  getFinancialData: async () => {
    const response = await api.get('/financial');
    return response.data;
  },

  // Update basic info (job and salary)
  updateBasicInfo: async (job, salary) => {
    const response = await api.put('/financial/basic', { job, salary });
    return response.data;
  },

  // Income operations
  addIncome: async (name, amount) => {
    const response = await api.post('/financial/incomes', { name, amount });
    return response.data;
  },

  deleteIncome: async (incomeId) => {
    const response = await api.delete(`/financial/incomes/${incomeId}`);
    return response.data;
  },

  // Expense operations
  addExpense: async (name, amount) => {
    const response = await api.post('/financial/expenses', { name, amount });
    return response.data;
  },

  deleteExpense: async (expenseId) => {
    const response = await api.delete(`/financial/expenses/${expenseId}`);
    return response.data;
  },

  // Asset operations
  addAsset: async (name, cost, type, cashflow) => {
    const response = await api.post('/financial/assets', { name, cost, type, cashflow });
    return response.data;
  },

  deleteAsset: async (assetId) => {
    const response = await api.delete(`/financial/assets/${assetId}`);
    return response.data;
  },

  // Liability operations
  addLiability: async (name, amount, payment) => {
    const response = await api.post('/financial/liabilities', { name, amount, payment });
    return response.data;
  },

  deleteLiability: async (liabilityId) => {
    const response = await api.delete(`/financial/liabilities/${liabilityId}`);
    return response.data;
  },
};

export default api;

